// ----------- Payment constants -----------

const PAYMENT_GATEWAY_PARAMETER: string = "gat";
const PAYMENT_GATEWAY_ID_ADYEN: string = "1357";
const PAYMENT_GATEWAY_ID_DATATRANS: string = "8312";
const UUID_PARAMETER: string = "uuid";
const PAYMENT_PAGE_SOURCE_PARAMETER: string = "ps";
const PAYMENT_PAGE_SOURCE_ADYEN: string = "ye";
const PAYMENT_PAGE_SOURCE_DATATRANS: string = "ran";
const PAYMENT_PAGE_SOURCE_CHECKOUT: string = "che";
const PAYMENT_STATE: string = "st";
const PAYMENT_STATE_SUCCESS: string = "scc";
const PAYMENT_STATE_CANCELLED: string = "can";
const PAYMENT_STATE_ERROR: string = "rro";
const PAYMENT_REASON_PARAM: string = "prp";
const PAYMENT_REASON_REFUSED: string = "prs";
const PAYMENT_METHOD_PARAMETER: string = "me";
const ORDER_UUID_PARAMETER: string = "oid";

const PASS_MIN_LENGTH: number = 8;

const REQUEST_SOURCE_HEADER: string = "X-Invoca-Request-Source";
const REQUEST_DEVICE_HEADER: string = "X-Invoca-Frontend-Device";
const REQUEST_ORIGIN_URL_HEADER: string = "X-Invoca-Frontend-Url";
const REQUEST_USER_AGENT: string = "X-Invoca-Frontend-Agent";
const REQUEST_IP_HEADER: string = "X-Invoca-Frontend-Ip";
const SOURCE_FRONTEND_CLIENT: string = "frontend-client";
const SOURCE_FRONTEND_BACKEND: string = process.env.NODE_ENV == "development" ? "frontend-backend-bypass" : "frontend-backend"
const SOURCE_FRONTEND_MIDDLEWARE: string = "frontend-middleware";
const FRONTEND_REFERRER_HEADER: string = "X-Invoca-Frontend-Referer"
const APP_SERVER_HEADER: string = "X-Invoca-Frontend-Server"

export {
  PAYMENT_GATEWAY_PARAMETER, UUID_PARAMETER, PAYMENT_GATEWAY_ID_ADYEN, PAYMENT_GATEWAY_ID_DATATRANS,
  PAYMENT_PAGE_SOURCE_PARAMETER, PAYMENT_PAGE_SOURCE_ADYEN, PAYMENT_STATE, PAYMENT_STATE_SUCCESS,
  PAYMENT_STATE_CANCELLED, PAYMENT_STATE_ERROR, PAYMENT_REASON_PARAM, PAYMENT_REASON_REFUSED,
  PAYMENT_PAGE_SOURCE_DATATRANS, PAYMENT_METHOD_PARAMETER, ORDER_UUID_PARAMETER, PAYMENT_PAGE_SOURCE_CHECKOUT,
  REQUEST_SOURCE_HEADER, REQUEST_DEVICE_HEADER, REQUEST_ORIGIN_URL_HEADER, SOURCE_FRONTEND_BACKEND,
  SOURCE_FRONTEND_CLIENT,
  SOURCE_FRONTEND_MIDDLEWARE,
  FRONTEND_REFERRER_HEADER,
  REQUEST_IP_HEADER,
  REQUEST_USER_AGENT,
  PASS_MIN_LENGTH,
  APP_SERVER_HEADER
};

